import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*
parniovlazivac u izradi

- 

TODO:
- 

*/


export const draftel_codecs_pack_terkk$_bundle_parniovlazivac = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_parniovlazivac.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_parniovlazivac',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$pov"), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input

    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_parniovlazivac.default_pods_input_state = () => {
  /*
  return {

  };
  */
  return default_pods_input_state_smart_get('terkk$parniovlazivac');
};


draftel_codecs_pack_terkk$_bundle_parniovlazivac.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_parniovlazivac_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default


    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_parniovlazivac.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 

  ...Object.keys(draftel_codecs_pack_terkk$_bundle_parniovlazivac.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_parniovlazivac.default_subform_item_preset_state())
];


/////////


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------




// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING

